import { api } from "../api/apiCore";

export function getCompanyGeotabData(data) {
	let url = `/company/geotab/partner/${data.partner_name}/companies/${data.company_name}`
	if (data.get_p) {
		url += '?p=true'
	}

	return api.get(url);
}

export function insertGeotabCompany (data) {
	const url = `/company/geotab/${data.company_id}`;

	var form = new FormData();
	if (data.database)
		form.append('database', data.database);
	if (data.email)
		form.append('email', data.email);
	if (data.password)
		form.append('password', data.password);
	if (data.sessionId)
		form.append('session_id', data.sessionId);
	if (data.path)
		form.append('path', data.path);
	if (data.fleet_token)
		form.append('token', data.fleet_token);

	return api.putForm(url, form);
}

export function deleteGeotabCompany(data) {
	const url = `/company/geotab/${data.company_id}`;

	return api.delete(url);
}
